import { Model } from "#/shared/models/model";

const uiDefaults = {
  rowgap: 0,
};
export class Settings extends Model {
  constructor(attributes = {}) {
    const ui = { ...uiDefaults, ...(attributes.ui ?? {}) };
    super({ ...attributes, ui });
  }

  get defaults() {
    return {
      rowgap: 0,
      ui: uiDefaults,
    };
  }
}
